export default "__VITE_ASSET__TT84a3W4__"